<template>
	<div class="page" data-name="payment-list">
		<f7-navbar>
			<f7-nav-left>
				<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
			</f7-nav-left>
			<div class="title">
				스마트 장바구니
			</div>			
			<f7-nav-right>
				<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
			</f7-nav-right>
		</f7-navbar>

		<!-- 상단 툴바 -->
		<div class="toolbar toolbar-top">
			<div class="toolbar-inner">		
				<label class="item-checkbox item-content" style="margin-left:10px;">
        	<input type="checkbox" name="checkbox-products" v-model="checkAllProduct"/>
        	<i class="icon icon-checkbox" style="margin-right:2px;float:left"></i>
					<div class="item-inner"  style="float:left">
						<div class="item-title" style="color:#000;">전체선택</div>
					</div>
      	</label>	
				<!--배송타입 선택-->
				<div class="row">
					<div class="col" style="width:auto;">		
						<label class="radio">
							<input type="radio" name="radio-addrType" value="company" v-model="radioAddrType">
							<i class="icon-radio" style="margin-right:2px;float:left"></i>
							<div class="item-inner"  style="float:left;margin-right:5px;">
								<div class="item-title" style="color:#000;">학원으로 배송</div>
							</div>
						</label>
					</div>
					<div class="col" style="width:auto">
						<label class="radio">
							<input type="radio" name="radio-addrType" value="user" v-model="radioAddrType">
							<i class="icon-radio" style="margin-right:2px;float:left"></i>
							<div class="item-inner"  style="float:left;margin-right:10px;">
								<div class="item-title" style="color:#000;">주소지로 배송</div>
							</div>
						</label>					
					</div>
				</div>			
			</div>
		</div>
		<!--상품 목록-->		
		<div class="page-content" style="background-color:#efeff4">
			<div class="list" style="margin-top:0px; padding-bottom:15px">
				<template v-for="(item, i) in paymentList">
					<div :key="'ii' + i" class="card card-outline">
						<div class="card-header ">
							<label class="item-checkbox item-content " style="padding-left:2px;">
								<input type="checkbox" name="checkbox-product" :value="i" v-model="checkProduct"/>
								<i class="icon icon-checkbox" style="margin-right:3px;float:left"></i>						
								<div class="item-title " style="color:#000;float:left">
									{{getProductType(i)}} ({{item.USER_NAME}} 학생)								
								</div>											
							</label>		
							<i class="f7-icons "  style="vertical-align:text-bottom;cursor:pointer" 
									v-on:click="deleteBasketItem(i)" v-if="item.DELETE_POSSIBLE == 'mine'">
								multiply_square_fill
							</i>
						</div>
						<div class="card-content card-content-padding">
							<div class="list media-list">
								<ul>
									<li class="item-content">
										<div class="item-media">
											<img :src="productImageUrl(i)" width="143" height="70"/>
										</div>
										<div class="item-inner">
											<div class="item-title-row">
												<div class="item-title">
												 	{{item.PRODUCT_NAME}}			
												</div>
											</div>
											<div class="item-subtitle">
												요청일 : {{getDate(i)}}
											</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
						<div class="card-footer">
							<div class="list no-hairlines-between" style="width:100%;">
								<ul>
									<li>
										<div class="item-content">										
											<div class="item-inner">
												<div class="item-title">상품금액 :</div>
												<div class="item-after" style="font-weight:bold;color:#ff0000"><s>{{getPrice(item.ORIGINAL_PRICE)}}원</s></div>
											</div>
										</div>								 
									</li>
									<!--
									<li>
										<div class="item-content">
											<div class="item-inner">
												<div class="item-title">할인금액 :</div>
												<div class="item-after"  style="font-weight:bold;color:#ff0000">
													-{{getPrice(item.DISCOUNT_PRICE)}}원
												</div>
											</div>
										</div>								 
									</li>							
									-->
									<li>
										<div class="item-content">
											<div class="item-inner">
												<div class="item-title" style="font-weight:bold;">주문금액 :</div>
												<div class="item-after" style="font-weight:bold;">
													{{getPrice(item.ORIGINAL_PRICE-item.DISCOUNT_PRICE)}}원
												</div>
											</div>
										</div>								 
									</li>		
								</ul>
							</div>				
						</div>
					</div>
				</template>			
			</div>
		</div>

		<!-- 하단 툴바 -->
		<div class="toolbar toolbar-bottom" >
			<div class="toolbar-inner" style="padding:5px;">							
				<div class="row" style="width:100%;height:100%">
					<div class="col" style="margin-left:5px;">
						<div><small style="color:#000">총: 
							<b style="color:#00aaff">{{checkProduct.length}}</b>개</small>
						</div>
						<div style="color:#000;font-weight:bold">{{getPrice(totalPrice)}}원</div>
					</div>  
					<div class="col" style="margin-right:5px;">
						<button class="button button-fill" v-on:click="finalPayment();">주문하기</button>							
					</div>
				</div>				
			</div>
		</div>

	</div>
</template>

<script>
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';
export default {
	data() {
    return {
			paymentList: [],
			checkProduct: [],
			radioAddrType:"company",
			totalPrice: 0
    }
	},
	watch: {
		
		checkProduct: function() {
			const _this = this;
			var price = 0;
			for(var i = 0; i < _this.checkProduct.length; i++) {
					
					var item = _this.paymentList[ _this.checkProduct[i]];					
					price += item.ORIGINAL_PRICE-item.DISCOUNT_PRICE;					
			}

			_this.totalPrice = price;
		}
		
	},
	computed: {
		checkAllProduct: {
			get: function() {
				const _this = this;

				if( (_this.checkProduct.length != _this.paymentList.length) 
					|| _this.paymentList.length == 0 ) {
					return false;
				}else{
					return true;
				}
			},
			set: function(event) {
				const _this = this;

				if(event) {
					for(var i = 0; i < _this.paymentList.length; i++) {
						_this.checkProduct.push(i);						
					}

				}else {
					_this.checkProduct = [];
				}
			}
		}
	},
  mounted() {
		const _this = this;
		_this.loadMyPaymentList();
  },
  methods: {
		
		deleteBasketItem(itemIndex) {
			const _this = this;
			var item = _this.paymentList[itemIndex];

			let requestInfo = {
				studentKey: item.STUDENT_KEY,
				productKey: item.PRODUCT_KEY
			}
			
			API.jsonRequest({
				url: API.deletePaymentBasketUrl(),
				data: requestInfo
			}).then(function (data) {
				_this.loadMyPaymentList();
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		},
		finalPayment() {
			const _this = this;
			var param = undefined;
			var finalPaymentList = [];

			if(_this.checkProduct.length == 0) {
				MODULE.DialogBox.message("결제 대상을 선택 하셔야 합니다.");
				return;
			}

			for(var i = 0; i < _this.checkProduct.length; i++) {
				var item = _this.paymentList[_this.checkProduct[i]];
				finalPaymentList.push(item);
			}

			param = {
				paymentList : finalPaymentList,
				radioAddrType : _this.radioAddrType
			}

			PAGES.popPage(PAGES.SUB_PAYMENT_FINAL_LIST, param);
		},
		getPrice(price) {
			const _this = this;
			var won = MODULE.Util.autoMakeComma(price);
			return won;
		},
		getDate(itemIndex) {
			const _this = this;
			var item = _this.paymentList[itemIndex];
			var thisDate = moment(item.UPDATE_DATETIME).format("YYYY.MM.DD");		
		
			return thisDate;
		},
		getProductType(itemIndex) {		
			const _this = this;
			var item = _this.paymentList[itemIndex];

			return  CONST.productType[item.PRODUCT_TYPE].name;
			
		},
		productImageUrl(itemIndex) {
			const _this = this;
			var item = _this.paymentList[itemIndex];
			var imgPath = MODULE.Util.getProductImgUrl(item.PRODUCT_KEY);			

			return imgPath;			
		},
		loadMyPaymentList() {
			const _this = this;
			
			let param = {};

			API.ajaxRequest({
				url: API.getPaymentListUrl(),
				data: param
			}).then(function (data) {
				_this.paymentList = data.paymentList;
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
		}
 
  }
}
</script>

